import { OpenAPICopyButton } from './OpenAPICopyButton';
import { getOpenAPIClientContext } from './context';
import { getDefaultServerURL } from './util/server';
/**
 * Display the path of an operation.
 */
export function OpenAPIPath(props) {
    var data = props.data, context = props.context, _a = props.withServer, withServer = _a === void 0 ? true : _a, _b = props.canCopy, canCopy = _b === void 0 ? true : _b;
    var method = data.method, path = data.path, operation = data.operation;
    var server = getDefaultServerURL(data.servers);
    var formattedPath = formatPath(path);
    var element = (function () {
        return (<>
                {withServer ? <span className="openapi-path-server">{server}</span> : null}
                {formattedPath}
            </>);
    })();
    return (<div className="openapi-path">
            <div className={"openapi-method openapi-method-".concat(method)}>{method}</div>

            <OpenAPICopyButton value={"".concat(withServer ? server : '').concat(path)} className="openapi-path-title" data-deprecated={operation.deprecated} isDisabled={!canCopy} context={getOpenAPIClientContext(context)}>
                {element}
            </OpenAPICopyButton>
        </div>);
}
/**
 * Format the path by wrapping placeholders in <span> tags.
 */
function formatPath(path) {
    // Matches placeholders like {id}, {userId}, etc.
    var regex = /\{\s*(\w+)\s*\}|:\w+/g;
    var parts = [];
    var lastIndex = 0;
    //Wrap the variables in <span> tags and maintain either {variable} or :variable
    path.replace(regex, function (match, _, offset) {
        if (offset > lastIndex) {
            parts.push(path.slice(lastIndex, offset));
        }
        parts.push(<span key={"offset-".concat(offset)} className="openapi-path-variable">
                {match}
            </span>);
        lastIndex = offset + match.length;
        return match;
    });
    if (lastIndex < path.length) {
        parts.push(path.slice(lastIndex));
    }
    var formattedPath = parts.map(function (part, index) {
        if (typeof part === 'string') {
            return <span key={"part-".concat(index)}>{part}</span>;
        }
        return part;
    });
    return formattedPath;
}
